module.exports = __webpack_public_path__ + "static/media/free-icon-resized.2bcf2818.svg";